import React, {useContext, useEffect, useState} from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import {DataContext} from "../contexts/DataContext";

export default function AdminSelector(props) {
    //const [adminLevel, setAdminLevel] = useState('adm0');
    //const [selectedAdm1, setSelectedAdm1] = useState('');

    const {options} = props;

    const {
        selectedAdmin,
        updateSelectedAdmin,
        selectedAdmin1,
        updateSelectedAdmin1,
        adm1Options,
        updateAdm1Options
    } = useContext(DataContext);

    // Define your adm1 options (replace with your actual data)
    //const allAdm1Options = ['Adm1 Option 1', 'Adm1 Option 2', 'Adm1 Option 3'];

    // Function to handle admin level selection
    const handleAdminLevelChange = (event) => {
        // do nothing
        const selectedLevel = event.target.value;
        updateSelectedAdmin(selectedLevel);

/*        if (selectedLevel === 'adm1') {
            //setAdm1Options(adm1Options);
            //updateSelectedAdmin(selectedLevel)
            updateSelectedAdmin1(selectedAdmin1)
        } else {
            //setAdm1Options([]);
            updateSelectedAdmin1(null)
        }*/
    };

    // Function to handle adm1 selection
    const handleAdm1Change = (event) => {
        updateSelectedAdmin1(event.target.value);
    };

    useEffect(() => {
        if (selectedAdmin === 'adm1') {
            updateAdm1Options(options)
            updateSelectedAdmin1(options[0])
        }
    }, [selectedAdmin])

    return (
        <div>
            <FormControl variant="outlined">
                <InputLabel>Admin Level</InputLabel>
                <Select
                    value={selectedAdmin}
                    onChange={handleAdminLevelChange}
                    label="Admin Level"
                >
                    <MenuItem value="adm0">Adm 0</MenuItem>
                    <MenuItem value="adm1">Adm 1</MenuItem>
                </Select>
            </FormControl>

            {selectedAdmin === 'adm1' && options && (
                <FormControl variant="outlined">
                    <InputLabel>Adm 1 Options</InputLabel>
                    <Select
                        value={selectedAdmin1 ? selectedAdmin1 : options[0]}
                        onChange={handleAdm1Change}
                        label="ADM1 Options"
                        defaultValue={options[0]}
                    >
                        {options.map((option, index) => (
                            <MenuItem key={index} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        </div>
    );
}
